/* 🤖 this file was generated by svg-to-ts */
export const siriusShareNetwork: {
  name: 'share_network';
  data: string;
} = {
  name: 'share_network',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 9a3.739 3.739 0 0 1-2.685-1.132l-4.318 2.775c.163.42.253.878.253 1.357s-.09.936-.253 1.357l4.318 2.775a3.75 3.75 0 1 1-.812 1.261l-4.318-2.775a3.75 3.75 0 1 1 0-5.236l4.318-2.775A3.75 3.75 0 1 1 16.5 9Zm-2.25-3.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm-6.332 7.927a.774.774 0 0 0-.05.079 2.25 2.25 0 1 1 .05-.078Zm6.664 4.395a2.25 2.25 0 1 0 3.835 2.355 2.25 2.25 0 0 0-3.835-2.355Z" fill="currentColor"/></svg>`
};
